var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"listmain "},[_c('h1',{staticClass:"firTitle"},[_vm._v("FreeRTOS硬件SDK")]),_vm._v(" "),_c('p',[_vm._v("为FreeRTOS硬件设备提供语音OS能力，目前已在demo测试中，即将上线。。\n   ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ad3028c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tutor/FSDK.vue
// module id = null
// module chunks = 